export default ":";
//# sourceMappingURL=separatorChar.js.map